// extracted by mini-css-extract-plugin
module.exports = {"loyaltyContainer":"Loyalty_loyaltyContainer__gY8e4"};